/* global advAppData, buildAppUrl */
/* eslint no-undef: "error" */

$(document).ready(function () {
  /* https://codepen.io/mmoradi08/pen/yLyYrGg */
  /* 1. Visualizing things on Hover - See next part for action on click */
  $('#stars li').on('mouseover', function () {
    var onStar = parseInt($(this).data('value'), 10) // The star currently mouse on
    // Now highlight all the stars that's not after the current hovered star
    $(this).parent().children('li.star').each(function (e) {
      (e < onStar) ? $(this).addClass('hover') : $(this).removeClass('hover')
    })
  }).on('mouseout', function () {
    $(this).parent().children('li.star').each(function (e) {
      $(this).removeClass('hover')
    })
  }).on('click', function () {
    const onStar = parseInt($(this).data('value'), 10) // The star currently selected
    const stars = $(this).parent().children('li.star')

    for (let i = 0; i < stars.length; i++) {
      $(stars[i]).removeClass('selected')
    }
    for (let i = 0; i < onStar; i++) {
      $(stars[i]).addClass('selected')
    }
    const ratingValue = parseInt($('#stars li.selected').last().data('value'), 10);
    (ratingValue > 1) ? $('#star_input').val(ratingValue) : $('#star_input').val('')
  })

  $('#review_submit').on('click', function (e) {
    e.preventDefault()
    const ratingValue = $('#star_input').val()
    if (ratingValue > 1) {
      $.ajax({
        type: 'POST',
        url: buildAppUrl(advAppData.uris.submitProductReview),
        dataType: 'json',
        data: {
          product_id: advAppData.productPage.productId,
          review_rating: ratingValue,
          review_name: $('#reviewname').val(),
          review_text: $('#reviewtext').val()
        },
        complete: function (data) {
          if (data.responseJSON.status === '1') {
            $('.reviews-content-wrapper').html('')
            $('.reviews-content-wrapper').html('<div class="col-12 alert alert-success text-lg text-center p-3 mt-2">Η αξιολόγηση προστέθηκε επιτυχώς !</div>')
          }
          if (data.responseJSON.status === '0') {
            $('.reviews-content-wrapper').html('')
            $('.reviews-content-wrapper').html(advAppData.t.productPageReviewsAjaxResponseFail)
          }
        }
      })
    }
  })
  $('#contactFormModal').appendTo("body")
})

$('.suggest-prod-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1
})

$('#launch-review-write').on('click', function () {
  $('html, body').animate({
    scrollTop: $('#product-page-tabs').offset().top -200 
  }, 2000);
  $('#product-page-tabs ul.tabs li').removeClass('current')
  $('#product-page-tabs .tab-content').removeClass('current')
  $('#product-page-tabs .tab-content#tab-4').addClass('current')
  $('#product-page-tabs ul.tabs li[data-tab="tab-4"]').addClass('current')
  return false
})

$('.prod-gallery-row').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
        arrows: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
})

$(document).on("submit", "[data-action='ajaxContactForm']", function(e) {
  e.preventDefault()
  e.stopPropagation()
  let formData = $(this).serializeArray()
  let action = $(this).prop('action')
  let method = $(this).prop('method')
  $.ajax({
    url: action,
    method: method,
    data: formData
  }).done(function () {
    Vue.$toasted.success('Η φόρμα έχει αποσταλεί επιτυχώς!', {
      duration: 5000,
      icon: { name: 'check' }
    })
    $("#contactFormModal").modal("hide")
  }).fail(function (xhr, ajaxOptions, thrownError) {
    Vue.$toasted.error(xhr.responseText, {
      duration: 5000,
      icon: { name: 'check' }
    })
  })
})
